
import cornerstoneTools from "cornerstone-tools";
export default class YubanyudianTool extends cornerstoneTools.ProbeTool {
    private createNewMeasurement(eventData) {
        return {
            visible: true,
            active: true,
            color: 'yellow',
            invalidated: true,
            handles: {
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true,
                },
            },
        };
    }
}
